import http from "@/settings/apiSettings"

// ID-uri fixe seed-uite de /api/Report/SeedFluturasReports (vezi FluturasReportSeeder.cs)
const FLUTURAS_REPORT_ID = "22222222-2222-2222-2222-222222220001";
const FLUTURAS_DESIGN_ID = "22222222-2222-2222-2222-222222220002";

class PORTAL_FluturasService {
  /** Lunile (DISTINCT Data) pentru care angajatul curent are calcul de salariu (desc). */
  getLuniDisponibile(): Promise<any> {
    return http.clientPortalHR.get("/portal/fluturas/luni", {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  /**
   * Generează PDF-ul fluturașului pentru (angajat, lună) prin mecanismul de rapoarte
   * DevExpress (modul Rapoarte). Întoarce un blob PDF.
   */
  getFluturasPdf(empId: string, data: string): Promise<any> {
    const body = [
      { Name: "empID", Value: empId, Type: "Guid" },
      { Name: "data", Value: data, Type: "DateTime" },
    ];
    return http.clientRapoarte.post(
      `/Report/GetReport?reportID=${FLUTURAS_REPORT_ID}&reportDesignID=${FLUTURAS_DESIGN_ID}`,
      body,
      { responseType: "blob", headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") } }
    );
  }
}

export default new PORTAL_FluturasService();
